import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./routes/AppRouter";
import { AuthProvider } from "./context/context";
import "./styles/global.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));

const App = () => (
    <React.StrictMode>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </React.StrictMode>
);

export default App;
root.render(<App />);
